import React, { useEffect, useState, useRef } from "react";
import Preloader from "../Components/Preloader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import AOS from "aos";
import ReCAPTCHA from "react-google-recaptcha";
import confetti from "canvas-confetti";

function Winner() {
  const [isLoading, setIsLoading] = useState(true);
  const [referenceNo, setReferenceNo] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [result, setResult] = useState(null);
  const [apiLoading, setApiLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const modalRef = useRef(null);
  const referenceHelpModal = useRef(null);
  const tcsModal = useRef(null);

  // Preloader
  useEffect(() => {
    setTimeout(() => setIsLoading(false), 500);
  }, []);

  // AOS init
  useEffect(() => {
    AOS.init({
      duration: 750,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  // SIDE CONFETTI
  useEffect(() => {
    const interval = setInterval(() => {
      confetti({ particleCount: 50, spread: 100, origin: { x: 0, y: 0.3 } });
      confetti({ particleCount: 50, spread: 100, origin: { x: 1, y: 0.3 } });
    }, 400);

    return () => clearInterval(interval);
  }, []);

  // CAPTCHA
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  // Get Prize Image Based on API Result
  const getPrizeImage = () => {
    if (!result) return "";

    if (result.prize?.toLowerCase() === "tv") {
      return "/assets/images/offer/win-tv.png";
    }
    if (result.prize?.toLowerCase() === "alexa") {
      return "/assets/images/offer/win-alexa.png";
    }
    return "/assets/images/offer/sad-next-time.png"; // Not winner
  };

  // SEARCH API
  const handleSearch = async () => {
    setErrorMessage("");

    if (!referenceNo.trim()) {
      setErrorMessage("Please enter your reference number.");
      return;
    }

    if (!captchaToken) {
      setErrorMessage("Please complete the CAPTCHA.");
      return;
    }

    try {
      setApiLoading(true);

      // YOUR LIVE API HERE
      const response = await fetch(
        `https://your-api.com/check-winner?ref=${referenceNo}`
      );

      const data = await response.json();

      if (response.ok) {
        setResult(data);

        // Confetti burst
        confetti({
          particleCount: 200,
          spread: 140,
          origin: { y: 0.5 },
        });

        const modal = new window.bootstrap.Modal(modalRef.current);
        modal.show();
      } else {
        setErrorMessage(data.message || "Invalid reference number.");
      }
    } catch (error) {
      setErrorMessage("Something went wrong. Please try again.");
    }

    setApiLoading(false);
  };

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <Header />

          {/* Banner */}
          <div className="banner-area bg-color-theme position-relative overflow-hidden">
            <div className="container">
              <div className="banner-content" data-aos="zoom-in-up" data-aos-delay={500}>
                <h1 className="text-white">
                  Happy Holidays Raffle Winners Announcement!
                </h1>
                <p className="mb-1" style={{ color: "#ffd38b" }}>
                  Ifepay congratulates all the lucky winners and thankful to all
                  the entrants.
                </p>
              </div>

              {/* Search Area */}
              <div className="text-center mt-5" data-aos="fade-up" data-aos-delay={400}>
                <label className="text-white mb-2">
                  Your reference no. e.g IF00000001
                </label>

                <div
                  className="d-flex align-items-center p-2 rounded mx-auto"
                  style={{
                    maxWidth: "500px",
                    background: "transparent",
                    border: "1px solid #fff",
                  }}
                >
                  <input
                    type="text"
                    className="form-control border-0 text-white"
                    style={{ background: "transparent", color: "white" }}
                    placeholder="Enter reference number"
                    value={referenceNo}
                    onChange={(e) => setReferenceNo(e.target.value)}
                  />

                  <button
                    className="btn btn-success rounded-circle ms-2"
                    onClick={handleSearch}
                    disabled={apiLoading}
                  >
                    {apiLoading ? (
                      <span className="spinner-border spinner-border-sm"></span>
                    ) : (
                      <i className="fa fa-search"></i>
                    )}
                  </button>
                </div>

                {errorMessage && (
                  <p className="text-danger mt-3 fw-bold">{errorMessage}</p>
                )}

                {/* HELP LINK */}
                <p
                  className="text-white mt-3 fw-bold text-decoration-underline"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    new window.bootstrap.Modal(referenceHelpModal.current).show()
                  }
                >
                  Where can I find my reference number?
                </p>

                {/* Ts & Cs */}
                <p
                  className="text-white text-decoration-underline"
                  style={{ cursor: "pointer" }}
                  onClick={() => new window.bootstrap.Modal(tcsModal.current).show()}
                >
                  Ts & Cs Apply*
                </p>

                {/* CAPTCHA */}
                <div className="mt-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LdJXrcqAAAAAICxBuvcI8Ndx7sROqAy_tHJ2JQH"
                    onChange={handleCaptchaChange}
                    theme="dark"
                  />
                </div>
              </div>
            </div>

            {/* Shapes */}
            <div className="shape-image">
              <img
                className="hero-shape-1 moveHorizontal_reverse"
                src="assets/images/offer/gift-box.png"
                alt="image"
                data-aos="zoom-in-up"
                data-aos-delay={500}
              />

              <img
                className="hero-shape-2 moveHorizontal_reverse"
                src="assets/images/offer/gift-box.png"
                alt="image"
                data-aos="zoom-in-up"
                data-aos-delay={500}
              />
            </div>
          </div>

          {/* RESULT MODAL */}
          <div className="modal fade" id="resultModal" ref={modalRef}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header bg-success text-white">
                  <h5 className="modal-title">🎉 Raffle Result</h5>
                  <button className="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div className="modal-body text-center">
                  {result ? (
                    <>
                      <img
                        src={getPrizeImage()}
                        alt="Prize"
                        className="img-fluid mb-3"
                        style={{ maxHeight: "200px" }}
                      />

                      <p>
                        <strong>Name:</strong> {result.name}
                      </p>
                      <p>
                        <strong>Prize:</strong> {result.prize}
                      </p>
                      <p>
                        <strong>Status:</strong> {result.status}
                      </p>
                    </>
                  ) : (
                    <p>No result found.</p>
                  )}
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* HELP MODAL */}
          <div className="modal fade" id="referenceHelp" ref={referenceHelpModal}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Where Can I Find My Reference Number?</h5>
                  <button className="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div className="modal-body text-center">
                  <img
                    src="/assets/images/offer/reference-number.png"
                    alt="reference"
                    className="img-fluid rounded"
                  />
                  <p className="mt-3">
                    Your reference number appears in the Settings section of the Ifepay App.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Ts & Cs MODAL */}
          <div className="modal fade" id="tcsModal" ref={tcsModal}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Ts & Cs Apply*</h5>
                  <button className="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div className="modal-body">
                  <p>
                    • Winners must comply with all Ifepay rules and eligibility criteria.
                    <br />
                    • Reference numbers must be valid and unique.
                    <br />
                    • Prizes are non-transferable.
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </div>

          <Footer />

          {/* Placeholder CSS */}
          <style>{`
            .form-control::placeholder {
              color: white !important;
              opacity: 1;
            }
          `}</style>
        </>
      )}
    </>
  );
}

export default Winner;
